import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { LocalizedStrict } from '../../../../localization/components/AppLocalized';
import { Link } from 'react-router-dom';
import { Player } from '@lottiefiles/react-lottie-player';
import SurveyAnimation from "../assets/animation_ljydnlcw.json"

export function SurveyPlaceholder() {
    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Box sx={{ maxWidth: "100%", }}>
                    <LocalizedStrict id='survey-placeholder-title' >
                        <Typography variant="h4" gutterBottom sx={{ marginTop: "1.5rem", textAlign: "center" }}>
                            Dashbordet kundetilfredshed kommer snart
                        </Typography>
                    </LocalizedStrict>

                    <LocalizedStrict id='survey-placeholder-subtitle' >
                        <Typography variant='body1' sx={{ marginBottom: "-2rem" }}>
                            Dit salgsdashboard vil vise en oversigt over vigtige nøgletal, så du hele tiden har et godt overblik over salget og den daglige drift.
                        </Typography>
                    </LocalizedStrict>
                    {/* <LocalizedStrict id="survey-placeholder-contact">
                    <Typography variant='body1'>
                        Kontakt <Link to="mailto:support@facilitynet.dk">support@facilitynet.dk</Link>
                    </Typography>
                </LocalizedStrict> */}

                    <Player src={SurveyAnimation} autoplay loop speed={1} style={{ height: "30rem" }} />
                </Box >
            </Box>
        </>
    )
}
